module.exports = __webpack_public_path__ + "img/2.cd5ddbfb.png";